import React from 'react'
import portrait from '../assets/dharshini.jpg'

function About(){
    return(
    <div id='about'>
    <h2>About Me</h2>
    <div className='about-layout'>
      <div className='about-image-card'>
        <img src={portrait} alt="Yogadharshini" className='about-image' />
      </div>
      <div className='about-text about-text-card'>
        <p className='about-intro'>This is Yogadharshini, a frontend developer with a background in English literature, which helps me approach design with clarity, structure, and storytelling. I enjoy turning design ideas into responsive, recruiter-friendly web interfaces.</p>
        <p>I focus on building clean layouts, solving UI/UX challenges, and continuously refining code for both performance and aesthetics.</p>
        <p>I’m persistent in debugging styling issues, quick to experiment with new approaches, and always eager to understand the “why” behind design decisions. My current focus is on creating polished portfolio projects that reflect both technical strength and personal creativity.</p>
      </div>
    </div>
    </div>
    )
}
export default About;
